import script from "./PlanosCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanosCadastro.vue?vue&type=script&setup=true&lang=js"

import "./PlanosCadastro.vue?vue&type=style&index=0&id=a03c1d78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a03c1d78"]])

export default __exports__